import { WEB_API_BASE_PATH } from "common/constants";
import { publicBucketUrlForEnv, s3EnvFromEnvVars } from "common/constants/s3";
import { isOnNodeJS } from "common/utils/context";
import { fetchWithTimeout } from "common/utils/fetchHelpers";

/** Public (unauthenticated) endpoint returning the environment's file-storage base URL. */
export const FILE_STORAGE_BASE_URL_PATH = `${WEB_API_BASE_PATH}/files/file-storage-base-url/`;

let cachedBaseUrl: Promise<string | null> | undefined;

async function fetchBaseUrl(): Promise<string | null> {
  try {
    const res = await fetchWithTimeout(FILE_STORAGE_BASE_URL_PATH);
    return (await res.json()) as string;
  } catch (e) {
    console.error(e);
    cachedBaseUrl = undefined;
    return null;
  }
}

/**
 * Fetches the public file-storage base URL for the current environment.
 *
 * On Node, resolves from `S3_ENV`/`DB_ENV`.
 * In the browser/worker, uses the API to fetch the base URL.
 */
export async function getFileStorageBaseURL(): Promise<string | null> {
  if (isOnNodeJS()) {
    const s3Env = s3EnvFromEnvVars() ?? "test";
    return publicBucketUrlForEnv(s3Env);
  }
  cachedBaseUrl ??= fetchBaseUrl();
  return cachedBaseUrl;
}

/**
 * Gets the URL of a file that was posted using postFile, with preserveFileName true!
 * @param preservedFileName Same name that was earlier passed to postFile.
 */
export async function getPostedFileURLByName(preservedFileName: string): Promise<string | null> {
  try {
    const baseURL = await getFileStorageBaseURL();
    if (baseURL === null) {
      return null;
    }
    return baseURL + preservedFileName;
  } catch (e) {
    console.error(e);
    return null;
  }
}
